import { render, staticRenderFns } from "./adiarAulaAlunoDialog.vue?vue&type=template&id=0381818e"
import script from "./adiarAulaAlunoDialog.vue?vue&type=script&lang=js"
export * from "./adiarAulaAlunoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports